<template>
  <div class="input-container" :class="{ 'required-fail': requiredFail }">
    <input
      :value="value"
      @input="updateValue($event.target.value)"
      type="email"
      :disabled="disabled"
      :placeholder="placeholder"
      :id="fieldId"
    />
  </div>
</template>

<script>
import { inputTypeMixin } from "@/mixins/forms/dynamicObjectForms/inputTypeMixin";

export default {
  name: "InputTypeEmailNPV",

  mixins: [inputTypeMixin]
};
</script>



// WEBPACK FOOTER //
// src/components/Npv/Configuration/components/InputTypesNPV/InputTypeEmailNPV.vue